<template>
  <div class="vedioPlay">
    <div v-if="isCollapse" class="collapse">
      <i class="el-icon-arrow-left" @click="isCollapse1()" v-show="isShowBtn"></i>
    </div>
    <div v-if="!isCollapse" class="collapse1">
      <i class="el-icon-arrow-right" @click="isCollapse1()" v-show="isShowBtn"></i>
    </div>

    <div :class="[isCollapse ? 'player1' : '', 'player']">
      <div class="prism-player" id="J_prismPlayer" @click="moveIn">
        <!-- <div class="title">{{vName}}</div> -->
      </div>
      <div v-show="isShowBtn" :class="[isCollapse ? 'title1' : '', 'title']">{{vName}}</div>
    </div>

    <transition name="el-zoom-in-center">
      <div class="vedioList" v-show="!isCollapse">
        <router-link :to="{path: '/vediolist', query: {courseId: this.courseId}}">
          <el-button type="primary" style="width:100%">关闭</el-button>
        </router-link>
        <div style="background:white;">
          <div style="height:36px;line-height:36px;background:white;font-size:14px;text-indent:10%;border:1px solid #ccc;"><strong>视频列表</strong></div>
          <div class="videoItemWrapper">
            <div class="videoItem" v-for="(item, index) in videoList" :key="index" @click="study(item.vid)">{{item.vName}}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      vName: this.$route.query.name,
      url: this.$route.query.url,
      courseId: this.$route.query.courseId,
      isCollapse: false,
      collapseImg: require('../../assets/aui-icon-menu.png'),
      noCollapseImg: require('../../assets/openclick.png'),
      isShowBtn: false,
      videoList: [],
      coverUrl: '',
      // baseUrl: 'http://192.168.199.193:3607/',
      baseUrl: 'https://www.teleicu.cn/',
    }
  },
  created() {
    // console.log('vid', this.$route.params.courseId)
    this.getCourseInfo()
  },
  mounted() {

  },
  methods: {
    createPlayer(coverUrl) {
      var player = new Aliplayer({
      id: "J_prismPlayer",
      source: this.url,
      // vid : '864ec7e61d0a4eada51a022c0aa6b5bf',
      width: "100%",
      height: "100%",
      cover: coverUrl,
      /* 设置封面时需要将 autoplay 和 preload 设置为 false */
      autoplay: false,
      preload: false,
      language: "zh-cn",
      isLive: false,
      qualitySort: 'desc',
      components: [{
        name: 'MemoryPlayComponent',
        type: AliPlayerComponent.MemoryPlayComponent,
      }]
      // components: [{
      //   name: 'PlaylistComponent',
      //   type: AliPlayerComponent.PlaylistComponent,
      //   args: [[{
      //     name: '阿里云视频云',
      //     source: 'http://player.pier39.cn/video/editor.mp4'
      //   }, {
      //     name: '趣拍演示视频',
      //     source: 'http://player.alicdn.com/resource/player/qupai.mp4'
      //   }, {
      //     name: '云栖大会',
      //     source: 'http://player.pier39.cn/video/yunxi.mp4'
      //   }, {
      //     name: '4K 阿里视频云介绍',
      //     source: 'https://player.alicdn.com/video/apsaravideo4k.mp4'
      //   }]]
      // }]

      }, function (player) {
        // console.log("播放器创建成功");
      });
    },
    // 查询视频信息
    getCourseInfo() {
      const _this = this;
      this.Axios.get(
        "/api/Education/GetEducationInfo?id=" + this.courseId
      ).then(res => {

        const data = res.data;
        if (data.status === 100) {
          // console.log(222, data.data.picture)
          // str.replace(/\\/g,"/")
          let url
          url = data.data.picture
          let coverUrl = this.baseUrl + url.replace(/\\/g,"/")
          // console.log(222, coverUrl)
          this.createPlayer(coverUrl)
          this.videoList = data.data.videos
        } else {
          this.$message({
            showClose: true,
            message: "网络错误,请联系管理员!",
            type: "success"
          });
        }
      });
    },
    // 播放视频
    study(vid) {
      this.Axios.get('/api/Education/GetVideoPath?id=' + this.courseId +'&vid=' + vid).then(res => {
        // console.log(res.data)
        const data = res.data
        if (data.status === 100) {
          // console.log(data)
          this.url = data.data[0]
        } else {
          this.$message({
            showClose: true,
            message: '获取视频地址失败,请重试!',
            type: 'error'
          })
        }
      })

    },
    moveIn() {
      this.isShowBtn = !this.isShowBtn
    },
    moveOut() {
      // console.log('moveOut')
      this.isShowBtn = false
    },
    isCollapse1() {
      this.isCollapse = !this.isCollapse
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
  }
}
</script>

<style lang="less" scoped>
.vedioPlay {
  /deep/ .el-icon-arrow-left {
    // background:rgba(0,0,0,0.0)
    opacity: 0.5;
    font-size: 20px;
    height: 50px;
    line-height: 50px;
  }
  /deep/ .el-icon-arrow-right {
    // background:rgba(0,0,0,0.0)
    opacity: 0.5;
    font-size: 20px;
    height: 50px;
    line-height: 50px;
  }
  overflow: hidden;
  height: 100%;
  .collapse {
    position: absolute;
    top: 49%;
    z-index: 9999;
    cursor: pointer;
    right: 0%;
    background: white;
  }
  .collapse1 {
    position: absolute;
    top: 49%;
    z-index: 9999;
    cursor: pointer;
    right: 20%;
    background: white;
  }
  .title {
    position: absolute;
    top: 0;
    text-align: center;
    z-index: 999;
    color: white;
    width: 80%;
    height: 126px;
    background: black;
    line-height: 126px;
    opacity: 0.5;
  }
  .title1 {
    position: absolute;
    top: 0;
    text-align: center;
    z-index: 999;
    color: white;
    width: 100%;
    height: 40px;
    background: black;
    line-height: 40px;
    opacity: 0.5;
  }
  /deep/ .el-icon-arrow-left {
    font-size: 20px;
    // color: white;
    // &.hover{
    //   color: rebeccapurple;
    // }
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100%;
    min-height: 400px;
  }
  .player {
    width: 80%;
    height: 100%;
    float: left;
  }
  .player1 {
    width: 100%;
    height: 100%;
    float: left;
  }
  .vedioList {
    width: 20%;
    height: 100%;
    float: right;
    overflow-y: scroll;
    // padding: 1%;
    // background: rebeccapurple;
    .videoItemWrapper {
      // padding: 15px;
      font-size: 12px;
      // padding-top: 0;
      // background: white;
      .videoItem {
        // margin-bottom: 10px;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #ccc;
        text-indent: 3%;
        cursor: pointer;
        &:hover {
          color: #409eff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/RemoteMedical/VedioPlay.vue